export default __webpack_public_path__ + "static/media/Vogel-auf-Früchtekorb.4ec17638.webp";